import {useLocation, useNavigate, useParams} from "react-router-dom";
import React, {useState} from "react";
import {
    RaikoBaseContainer,
    RaikoBreadcrumb,
    RaikoGridOneColumn,
    raikoBreadCrumbItemGenerator,
    RaikoFlexFirstChildGrowOne, RaikoButtonSecondary
} from "@moeindal/base-raiko-panel-components";
import {RouteHelper} from "../../../route/RouteHelper";
import {css} from "@emotion/css";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabPanel from "@mui/lab/TabPanel";
import MawakibBasicInfo from "./MawakibBasicInfo";
import MawakibRegisterList from "./MawakibRegisterList";
import MawakibServantRegisters from "./MawakibServantRegisters";
import MawakibDetailsReports from "./MawakibDetailsReports";

export default function MawakibDetails() {

    const {id: mawakibId = -1} = useParams()
    const {state} = useLocation();


    const [selectedValueTabMenu, setSelectedValueTabMenu] = useState(mawakibTabType.BasicInformation.id)

    const [pageTitle, setPageTitle] = useState(state && state.title ? state.title : RouteHelper.MawakibManagerList.name);

    function handleChangeTabMenu(event, newValue) {
        setSelectedValueTabMenu(newValue)
    }

    const navigate = useNavigate()


    return (
        <RaikoBaseContainer>
            <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                <RaikoFlexFirstChildGrowOne>
                    <RaikoBreadcrumb
                        breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.MawakibManagerList.name,
                                RouteHelper.MawakibManagerList.globalUrl
                            ),
                            raikoBreadCrumbItemGenerator(
                                pageTitle,
                                ""
                            )
                        ]}
                    />
                    <RaikoButtonSecondary
                        label={"بازگشت"}
                        onClick={_ => {
                            navigate(-1)
                        }}
                    />
                </RaikoFlexFirstChildGrowOne>

                <TabContext value={selectedValueTabMenu}>
                    <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                        <TabList onChange={handleChangeTabMenu} id="default-tab-container" variant="scrollable">
                            <Tab
                                label={mawakibTabType.BasicInformation.title}
                                value={mawakibTabType.BasicInformation.id}
                            />
                            <Tab
                                label={mawakibTabType.RegisteredList.title}
                                value={mawakibTabType.RegisteredList.id}
                            />
                            <Tab
                                label={mawakibTabType.ServantRegisters.title}
                                value={mawakibTabType.ServantRegisters.id}
                            />
                            <Tab
                                label={mawakibTabType.RegisteredReport.title}
                                value={mawakibTabType.RegisteredReport.id}
                            />

                        </TabList>
                    </Box>
                    <TabPanel value={mawakibTabType.BasicInformation.id}>
                        <MawakibBasicInfo mawakibId={mawakibId}/>
                    </TabPanel>
                    <TabPanel value={mawakibTabType.RegisteredList.id}>
                        <MawakibRegisterList mawakibId={mawakibId}/>
                    </TabPanel>
                    <TabPanel value={mawakibTabType.ServantRegisters.id}>
                        <MawakibServantRegisters mawakibId={mawakibId}/>
                    </TabPanel>
                    <TabPanel value={mawakibTabType.RegisteredReport.id}>
                        <MawakibDetailsReports name={pageTitle}/>
                    </TabPanel>
                </TabContext>
            </RaikoGridOneColumn>

        </RaikoBaseContainer>
    )
}

const mawakibTabType = {
    BasicInformation: {
        id: "basic-information",
        title: "اطلاعات پایه",
    },
    RegisteredList: {
        id: "select-photo",
        title: "لیست مواکب",
    },
    ServantRegisters: {
        id: "servant-registers",
        title: "لیست خدام",
    },
    RegisteredReport: {
        id: "report",
        title: "گزارش گیری",
    },

}